export const THEME_OPTIONS = [
  { id: 'dark', label: 'Dark' },
  { id: 'light', label: 'Light' },
];

export const PRIMARY_OPTIONS = [
  { id: 'orange', label: 'Orange' },
  { id: 'red', label: 'Red' },
  { id: 'blue', label: 'Blue' },
];

export const DEFAULT_THEME = 'dark';
export const DEFAULT_PRIMARY = 'orange';
